import { databases } from '@/lib/appwrite';
import { ID, Query } from 'appwrite';

// startBreak.ts
export const startBreak = async (
  userId: string,
  sessionId: string,
  startTime: Date,
  location: [string, string] // Ahora espera strings
) => {
  return databases.createDocument(
    import.meta.env.VITE_APPWRITE_DATABASE_ID,
    import.meta.env.VITE_WORK_BREAKS_COLLECTION_ID,
    ID.unique(),
    {
      userId,
      workSessionId: sessionId,
      startTime: startTime.toISOString(),
      location, // Ya viene como array de strings
      isActive: true
    }
  );
};

// endBreak.ts
export const endBreak = async (breakId: string, endTime: Date, duration: number) => {
  return databases.updateDocument(
    import.meta.env.VITE_APPWRITE_DATABASE_ID,
    import.meta.env.VITE_WORK_BREAKS_COLLECTION_ID,
    breakId,
    {
      endTime: endTime.toISOString(),
      breakDuration: duration,
      isActive: false
    }
  );
};

export const getActiveBreak = async (userId: string, sessionId: string) => {
  return databases.listDocuments(
    import.meta.env.VITE_APPWRITE_DATABASE_ID,
    import.meta.env.VITE_WORK_BREAKS_COLLECTION_ID,
    [
      Query.equal('userId', userId),
      Query.equal('workSessionId', sessionId),
      Query.equal('isActive', true)
    ]
  );
};

// getFinishedBreaks.ts

export const getFinishedBreaks = async (userId: string, sessionId: string) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0); // inicio del día

  return databases.listDocuments(
    import.meta.env.VITE_APPWRITE_DATABASE_ID,
    import.meta.env.VITE_WORK_BREAKS_COLLECTION_ID,
    [
      Query.equal("userId", userId),
      Query.equal("workSessionId", sessionId),
      Query.equal("isActive", false),
      Query.greaterThanEqual("startTime", today.toISOString()),
    ]
  );
};
